import React from 'react'
import PropTypes from 'prop-types'
import getLoginToken from 'meteor-apollo-accounts/client/getLoginToken'
import omit from 'lodash/omit'
import styles from './styles.css'

export default class ContractImage extends React.Component {
  static propTypes = {
    page: PropTypes.object,
    height: PropTypes.number
  }

  state = {
    url: ''
  }

  async componentDidMount() {
    const response = await window.fetch(this.props.page.url, {
      method: 'POST',
      dataType: 'binary',
      headers: {
        authorization: await getLoginToken()
      }
    })
    const body = await response.blob()
    const reader = new window.FileReader()
    reader.readAsDataURL(body)
    reader.onloadend = () => {
      this.setState({url: reader.result})
    }
  }

  render() {
    const props = omit(this.props, 'page')
    return (
      <div style={{height: this.props.height}} className={styles.container}>
        {this.state.url ? (
          <img
            style={{height: this.props.height, 'WebkitUserDrag': 'none'}}
            {...props}
            src={this.state.url}
            alt="Contract"
          />
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/ContractImage/index.js